export const GA_MEASUREMENT_ID = "G-P7SH8MTMEP";
